export default {
  restrictedJurisdictions: state => state.restrictedJurisdictions,
  jurisdictionsCountries: state => state.jurisdictionsCountries,
  totalCountriesCount: state => state.totalCountriesCount,
  jurisdictionsStatesAndRegions: state => state.jurisdictionsStatesAndRegions,
  totalStatesAndRegionsCount: state => state.totalStatesAndRegionsCount,
  editableCountry: state => state.editableCountry,
};
